export enum ApiRoutesAiAssistants {
  Assistants = "admin/ai-assistants"
}

export enum AiAssistantSubRoute {
  Rules = "rules",
  ReorderRules = "rules/reorder",
  Tools = "tools",
  ExpertSettings = "expert-settings",
  EffectivePrompt = "effective-prompt",
  Stats = "stats",
  SandboxSessions = "sandbox/sessions",
  Lessons = "lessons",
  LessonsEnabled = "lessons-enabled",
  LessonDraftAssist = "lessons/draft-assist"
}

export const AI_ASSISTANTS_QUERY_KEY = "ai-assistants";
